// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_KNY6s{flex:1 1 auto;width:100%;font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.tabsBar_N-umL{position:relative;display:flex;flex:0 1 auto;border-radius:inherit;height:48px;max-width:100%;color:#272525}.sliderWrapper_dPlTt,.tabsBar_N-umL{transition:.3s cubic-bezier(.25,.8,.5,1)}.sliderWrapper_dPlTt{position:absolute;bottom:0;margin:0!important;z-index:1}.slider_HiJkL{height:100%;width:100%;background-color:currentColor}", ""]);
// Exports
exports.locals = {
	"container": "container_KNY6s",
	"tabsBar": "tabsBar_N-umL",
	"sliderWrapper": "sliderWrapper_dPlTt",
	"slider": "slider_HiJkL"
};
module.exports = exports;
